import {
    NestedCheckboxGroupOptionType,
    NestedCheckboxGroup,
} from '../NestedCheckboxGroup/NestedCheckboxGroup'
import { DataSetTreeNodeGroup } from '@/components/organisms/DataSetTreeNode/DataSetTreeNode'
import { extractKeysToPlot } from '@/components/organisms/MultiChart/extractKeysToPlot'
import { UsageCostRequestParams, useAnalyticsApi } from '@/hooks'
import { processChartData } from '@/utils/processChartData'

type DataSetsProps = {
    options: NestedCheckboxGroupOptionType[]
    activeDataSets: string[]
    onChange: (dataSets: string[]) => void
    filters: UsageCostRequestParams
}

export const DataSets = (props: DataSetsProps) => {
    const { options, onChange, activeDataSets, filters } = props
    return (
        <div className="space-y-6">
            {options.map((dataSetsGroup) => {
                return (
                    <DataSetsGroup
                        key={dataSetsGroup.value}
                        title={dataSetsGroup.label}
                        options={dataSetsGroup.children ?? []}
                        activeDataSets={activeDataSets}
                        onChange={onChange}
                        filters={filters}
                    />
                )
            })}
        </div>
    )
}

type DataSetsGroupProps = {
    title: React.ReactNode
    options: React.ComponentProps<typeof NestedCheckboxGroup>['options']
    activeDataSets: string[]
    onChange: (dataSets: string[]) => void
    filters: UsageCostRequestParams
}

export const DataSetsGroup = (props: DataSetsGroupProps) => {
    const { title, options, onChange, activeDataSets, filters } = props
    const { useUsageCostQuery } = useAnalyticsApi()
    const { data } = useUsageCostQuery(filters)
    const processedData = processChartData(data?.items ?? [], {}, 'date')
    const dataKeys = extractKeysToPlot(processedData, 'date')
    const dataKeysPlottedRight = dataKeys.filter((dataSet) =>
        dataSet.includes('cost_')
    )
    const dataKeysPlottedLeft = dataKeys.filter(
        (dataSet) => !dataKeysPlottedRight.includes(dataSet)
    )
    const dataKeysOrdered = dataKeysPlottedLeft
        .concat(dataKeysPlottedRight)
        .filter((dataSet) => activeDataSets.includes(dataSet))

    const handleChange = (newCheckedItems: string[]) => {
        onChange(newCheckedItems)
    }

    if (!options.length) {
        return null
    }

    return (
        <div className="space-y-2">
            <div className="text-heading-caps">{title}</div>
            <div className="-ml-3">
                <DataSetTreeNodeGroup
                    options={options}
                    checkedItems={dataKeysOrdered}
                    onChange={handleChange}
                />
            </div>
        </div>
    )
}
